import React, { useMemo, useState } from "react";
import { SERVICES, PROJECTS } from "@/data/site";
import ReviewsSlider from "@/components/ReviewsSlider";
import { useInView } from "@/hooks/useReveal";

const PROJECT_SERVICE = ["lemezfedes", "cserepteto", "lemezfedes", "tetofelujitas", "lemezfedes", "tetoszerkezet", "cserepteto", "tetoszerkezet"];

const FILTERS = [
  { id: "all", label: "Mind" },
  ...SERVICES.map((s) => ({ id: s.slug, label: s.shortTitle })),
];

export default function References() {
  const [filter, setFilter] = useState("all");
  const [ref, inView] = useInView();

  const filtered = useMemo(() => {
    return PROJECTS.map((p, i) => ({ ...p, srv: PROJECT_SERVICE[i] }))
      .filter((p) => filter === "all" || p.srv === filter);
  }, [filter]);

  return (
    <section
      id="referenciak"
      ref={ref}
      data-testid="references-section"
      className="section bg-grid"
      style={{ background: "var(--ink)", position: "relative" }}
    >
      <div className="site-container" style={{ position: "relative", zIndex: 1 }}>
        <div
          className="ref-head"
          style={{ display: "grid", gridTemplateColumns: "1fr", gap: 28, marginBottom: 36 }}
        >
          <style>{`
            @media (min-width: 900px) {
              .ref-head { grid-template-columns: 1fr 1fr !important; gap: 80px !important; align-items: end !important; }
            }
          `}</style>
          <div className={`reveal ${inView ? "in-view" : ""}`}>
            <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 20 }}>
              <span style={{ height: 1, background: "var(--gold)", width: 32 }} />
              <span className="eyebrow" data-testid="ref-eyebrow">04 — Referenciák</span>
            </div>
            <h2 className="h2" data-testid="ref-h2" style={{ margin: 0 }}>
              Néhány a legutóbbi <span style={{ color: "var(--gold)" }}>munkáinkból.</span>
            </h2>
          </div>
          <p className={`lead reveal reveal-1 ${inView ? "in-view" : ""}`} style={{ margin: 0, maxWidth: 460 }}>
            Bármelyik ingatlanra szívesen elvisszük személyesen — a tulajdonosok szívesen beszélnek a tapasztalatukról.
          </p>
        </div>

        {/* Filter chips */}
        <div style={{ display: "flex", gap: 8, marginBottom: 32, flexWrap: "wrap" }} data-testid="ref-filters">
          {FILTERS.map((f) => (
            <button
              key={f.id}
              onClick={() => setFilter(f.id)}
              className={`chip ${filter === f.id ? "active" : ""}`}
              data-testid={`ref-filter-${f.id}`}
            >
              {f.label}
            </button>
          ))}
        </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: 16,
              minHeight: 240,
            }}
            data-testid="ref-grid"
          >
            {filtered.length === 0 && (
              <div style={{ padding: 40, gridColumn: "1 / -1", background: "var(--ink-2)", border: "1px solid var(--line)", textAlign: "center", color: "var(--text-dim)" }}>
                Erre a szakterületre még nincs feltöltött referencia ezen az oldalon.
              </div>
            )}
            {filtered.map((p, idx) => (
              <article
                key={p.title}
                data-testid={`project-card-${idx}`}
                className="tile"
                style={{ aspectRatio: "4 / 3", minHeight: 240 }}
              >
                <div
                  className="tile-img"
                  style={{
                    position: "absolute", inset: 0,
                    backgroundImage: `url("${p.photo}")`,
                    backgroundSize: "cover", backgroundPosition: "center",
                  }}
                />
                <span
                  className="eyebrow"
                  style={{
                    position: "absolute", top: 16, left: 16, zIndex: 2,
                    background: "var(--ink)", padding: "5px 10px",
                    border: "1px solid var(--gold-deep)",
                    fontSize: 10,
                  }}
                >
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <div style={{
                  position: "absolute", left: 0, right: 0, bottom: 0, zIndex: 2,
                  padding: "32px 16px 16px",
                  background: "linear-gradient(to top, rgba(11,10,9,0.88) 0%, rgba(11,10,9,0) 100%)",
                }}>
                  <span style={{ fontFamily: "Manrope, sans-serif", fontWeight: 600, fontSize: 13.5, color: "var(--text)", letterSpacing: "-0.01em" }}>
                    {p.title}
                  </span>
                </div>
              </article>
            ))}
          </div>

        {/* Reviews */}
        <div style={{ marginTop: 96 }}>
          <ReviewsSlider />
        </div>
      </div>
    </section>
  );
}
